// MUI
import { Grid } from "@mui/material";

import PropTypes from "prop-types";

export function TabPanel(props) {
	const { children, classname, style, selectedValue, index, ...other } = props;

	return (
		<div
			className={classname}
			style={{
				width: "100%",
				...style,
				left: 0,
				display: index !== selectedValue ? "none" : "inline-block",
			}}
			{...other}
		>
			{children}
		</div>
	);
}

export default function TabsPanels(props) {
	return (
		<Grid item xs={12} sx={{ marginX: "30px" }} {...props.contentProps}>
			{props.content?.map((element, key) => (
				<TabPanel value={key} selectedValue={props.value} index={key} key={element?.key} classname="mt-[18px]">
					{element}
				</TabPanel>
			))}
		</Grid>
	);
}

TabsPanels.propTypes = {
	value: PropTypes.number,
};
